export default __webpack_public_path__ + "static/media/photo2.99db3a1a.jpg";